import { useSelector } from 'react-redux';
import DossierClarificationDetails from '../../../../components/dossier-clarification/DossierClarificationDetails';
import { CLARIFICATION_STAKEHOLDERS_RESOURCE } from '../../../../resources/clarification.stakeholders.resource';
import { tableDataSelector } from '../../../../selectors/resources.selectors';

const DossierClarificationDetailsContainer = ({ clarification, dossierId, read, write, onUpdated }) => {
  const { data: stakeholders } = useSelector((state) =>
    tableDataSelector(state, { resource: { key: `${CLARIFICATION_STAKEHOLDERS_RESOURCE.key}_${clarification.id}` } })
  );

  if (!read || stakeholders.length < 1) {
    return null;
  }

  return <DossierClarificationDetails {...clarification} write={write} dossierId={dossierId} onUpdated={onUpdated} />;
};

export default DossierClarificationDetailsContainer;
